<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img">
        <img src="/assets/index/product-1.jpg" alt=""></img>
      </div>
      <div class="detail-banner-r">
        <div class="detail-banner-t1">
          动力系统
        </div>
        <div class="detail-banner-t2">
          4D24 柴油机
        </div>
        <div class="detail-banner-desc">
          这是一段对产品的简介，如适用于雪场等明亮环境下的xxx使用，针对xxxx板上的关键元器件(电容、电感、连接器等)的XY位置、Z向高度以及xxxxxx脚高度等尺寸的量测。
        </div>
        <div class="detail-banner-btn">
          <div>
            联系我们
          </div>
          <img src="/assets/index/right.png" alt="">
        </div>
      </div>
    </div>

    <div class="detail-center">
      <div class="detail-center-l">
        <div class="detail-text-box">
          <div class="detail-title">
            产品说明（慕尼黑演讲稿）
          </div>
          <div class="detail-desc">
            本展品含三块 15.6 英寸 2.5K 显示屏，展示车载显示主流技术：侧入式背光、mini LED 背光及 AMOLED 有机自发光。三块屏均为 2560RGB×1440
            分辨率，采用窄边框薄型设计，具备高亮度、高对比度、高色域、低蓝光特性。
            左侧：侧入式背光技术，1500:1 对比度、95% DCI-P3 色域，软硬件平台化设计，支持定制以适配不同场景与空间布局。
            中间：mini LED 背光技术，0 OD 设计，灯板集成特殊光学结构；总成厚度仅 8.5mm，达 96% DCI-P3 色域、2000nit 峰值亮度，光晕接近
            OLED；还可调节画质（亮度、饱和度等），画面更清晰真实。
            右侧：AMOLED 自发光技术，屏幕为双层发光结构 + 薄膜封装；实现 1000nit 亮度、99% DCI-P3 色域，显示总成边框与厚度均 5.5mm，T80 寿命超 10000 小时；可耐受 -
            40℃~95℃极端环境，满足智能座舱需求，同时提升科技感与驾乘体验。
          </div>

        </div>

        <div class="detail-text-box">
          <div class="detail-title">
            产品介绍
          </div>
          <div class="detail-desc">
            <div class="detail-desc-list">
              网络：支持2/3/4/5G（NR） 和C-V2X 通信,最大通信速率： 2.1 G (DL)/ 500M(UL) bps
            </div>
            <div class="detail-desc-list">
              标准：支持3GPP Rel-15 Sub-6SA/NSA100MHz
            </div>
            <div class="detail-desc-list">
              平台化设计：兼容5G/5G+V2X设计
            </div>
            <div class="detail-desc-list">
              导航：集成多模多频导航模组;
            </div>
            <div class="detail-desc-list">
              车用以太网总线架构，以太网支持DOIP，SOMEIP协议，支持1000 BASE T1（兼容100 BASE T1）
            </div>
          </div>
        </div>

        <div class="detail-text-box">
          <div class="detail-title">
            产品介绍
          </div>
          <div class="table-container">
            <table class="device-table">
              <tbody>
                <tr>
                  <td>CPU core</td>
                  <td>ARM Cortex A7</td>
                </tr>
                <tr>
                  <td>CPU frequency</td>
                  <td>up to 1.5 GHz</td>
                </tr>
                <tr>
                  <td>Computing Power</td>
                  <td>12.88K DMIPS</td>
                </tr>
                <tr>
                  <td>DL/UL Data rate</td>
                  <td>Up to 2.1 G / 500M bps</td>
                </tr>
                <tr>
                  <td>存储器/Memory</td>
                  <td>8Gb LPDDR4K+8Gb Nand Flash</td>
                </tr>
                <tr>
                  <td>以太网/Ethernet</td>
                  <td>1000 Base-T1</td>
                </tr>
                <tr>
                  <td>定位精度/Position Accuracy</td>
                  <td>ub · dm</td>
                </tr>
                <tr>
                  <td>制程/Process</td>
                  <td>7nm</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


      <div class="detail-center-r">
        <div class="detail-floating">
          <div class="floating-img img-box">
            <img src="/assets/index/product-1.jpg" alt=""></img>
          </div>
          <div class="floating-title">
            有问题吗? <br>
            蜂巢汽车顾问为您服务!
          </div>
          <div class="floating-phone">
            <img src="" alt="">
            <div class="phone-text">18888888888</div>
          </div>
          <div class="floating-phone">
            <img src="" alt="">
            <div class="phone-text">fengchaoqiche@fgung.com</div>
          </div>

          <div class="floating-btn">
            <div>
              联系我们
            </div>
            <img src="/assets/index/right.png" alt="">
          </div>
        </div>

      </div>

    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

</script>

<script>
export const pageConfig = {
  title: '传动',
  outputPath: 'transmission/product-detail.html'
};

import { createApp } from 'vue';
import App from './product-detail.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./product-detail.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped>
.product-detail-page {
  .detail-banner {
    width: calc(100% - 3.12rem);
    padding: 0 1.56rem;
    height: 7.34rem;
    background: #F6F8FA;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.88rem;
    padding-top: 0.91rem;

    .detail-banner-img {
      width: 5.52rem;
    }

    .detail-banner-r {
      width: 6.26rem;

      .detail-banner-t1 {
        font-weight: 500;
        font-size: 0.23rem;
        color: #E70012;
        margin-bottom: 0.37rem;
      }

      .detail-banner-t2 {
        font-weight: 500;
        font-size: 0.4rem;
        color: #000;
        padding-bottom: 0.37rem;
        margin-bottom: 0.37rem;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.16);
      }

      .detail-banner-desc {
        font-size: 0.18rem;
        color: #676767;
        font-weight: 400;
        line-height: 0.35rem;
        margin-bottom: 1.19rem;
      }

      .detail-banner-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.71rem;
        height: 0.45rem;
        background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
        border-radius: 0.26rem;
        color: #fff;

        div {
          font-size: 0.13rem;
          font-weight: 400;
          text-align: center;
          width: 60%;
        }

        img {
          width: 0.25rem;
          height: 0.25rem;
          object-fit: cover;
        }
      }
    }
  }

  .detail-center {
    padding: 1.19rem 1.56rem;
    width: calc(100% - 3.12rem);
    position: relative;
    display: flex;

    .detail-center-l {
      width: 60%;
    }

    .detail-center-r {
      width: 40%;
    }

    .detail-text-box {
      margin-bottom: 0.77rem;
      padding-bottom: 0.77rem;
      border-bottom: 1px solid #E3E3E3;

      .detail-title {
        font-size: 0.4rem;
        color: #000;
        font-weight: 500;
        margin-bottom: 0.51rem;
      }

      .detail-desc {
        font-size: 0.16rem;
        color: #676767;
        font-weight: 300;

        .detail-desc-list {
          padding-left: 0.29rem;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            width: 0.07rem;
            height: 0.07rem;
            left: 0;
            top: 0.04rem;
            background: #E70012;
            border-radius: 0.07rem;
          }
        }
      }

      .table-container {
        background-color: #f0f8ff;

        .device-table {
          width: 100%;
          border-collapse: collapse;

          td {
            border: 1px solid #fff;
            text-align: left;
            font-size: 0.18rem;
            font-weight: 400;
            color: #000;
            width: 3.25rem;
            height: 0.62rem;
            text-indent: 0.29rem;

            &:nth-child(2) {
              color: #747474;
              width: 3.67rem;
            }
          }

          tr:nth-child(odd) {
            background-color: #F2F2F2;
          }

          tr:nth-child(even) {
            background-color: #F6F8FA;
          }
        }
      }

      &:nth-last-child(1) {
        margin-bottom: 0;
        border-bottom: unset;
      }

    }
    .no-border-bottom {
      margin-bottom: 0;
      border-bottom: unset;
    }

    .detail-center-r {
      width: 40%;

      .detail-floating {
        position: sticky;
        top: 0.74rem;
        left: 13rem;
        z-index: 9;
        width: 4.14rem;
        height: 5.11rem;
        background: #F6F8FA;
        border-radius: 0.1rem;
        overflow: hidden;

        .floating-title {
          margin-top: 0.4rem;
          margin-left: 0.29rem;
          margin-bottom: 0.25rem;
        }

        .floating-phone {
          margin-bottom: 0.11rem;
          margin-left: 0.29rem;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 0.18rem;
          color: #9E9E9E;
        }

        .floating-btn {

          display: flex;
          justify-content: center;
          align-items: center;
          width: 3.62rem;
          height: 0.45rem;
          background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
          border-radius: 0.26rem;
          color: #fff;
          margin: 0 auto;

          div {
            font-size: 0.13rem;
            font-weight: 400;
            text-align: center;
            width: 80%;
          }

          img {
            width: 0.25rem;
            height: 0.25rem;
            object-fit: cover;
          }
        }
      }
    }

  }
}
</style>